import { render, staticRenderFns } from "./Slots.vue?vue&type=template&id=418f4b12&scoped=true&lang=pug&"
import script from "./Slots.vue?vue&type=script&lang=js&"
export * from "./Slots.vue?vue&type=script&lang=js&"
import style0 from "./Slots.vue?vue&type=style&index=0&id=418f4b12&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418f4b12",
  null
  
)

/* custom blocks */
import block0 from "./Slots.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports